module.exports = __webpack_public_path__ + "img/instagram.f6a53100.png";